import PropTypes from 'prop-types';
import styles from './styles';
import { RecipeMainTitle, RecipeSubTitle, RecipeList } from './';

const RecipeBarbacoaBeefTaco = ({ data }) => {
  return (
    <article className={`${styles.article} ${styles.borderBottom}`}>
      <div className='text-center' id='recipe-detail-ing-prep'>
        <RecipeMainTitle headline={data.title} color={data.color} />
        <RecipeSubTitle headline={data.recipes[0].title} id={data.recipes[0].id} m='lg:mb-[12rem]' />
        <img
          src={data.recipes[0].img}
          alt={data.recipes[0].alt + ' recipe'}
          className={`${styles.barbacoaBeefTacoImg()}`}
        />
      </div>
      <RecipeList
        title='Ingredients'
        color={data.color}
        list={data.recipes[0].recipe[0].ingredients}
      />
      <div className='justify-between lg:flex lg:gap-x-6'>
        <RecipeList
          title='Directions'
          color={data.color}
          list={data.recipes[0].recipe[0].directions}
          basis='lg:basis-[40%] '
          borderRight='after:right-[-12px] after:1.5xl:right-0'
        />
        <div className='relative gap-x-2 lg:flex lg:basis-[60%]'>
          {data.recipes[0].flag && (
            <span className={styles.flag(data.bgColor, 'left-[40%]')}>
              {data.recipes[0].flag}
            </span>
          )}
          {['Ingredients', 'Directions'].map((title, i) => (
            <RecipeList
              title={title}
              color={data.color}
              list={data.recipes[0].recipe[1][title.toLowerCase()]}
              basis={`lg:basis-[50%] xl:basis-[${!i ? '4' : '5'}5%] `}
              key={i}
            />
          ))}
        </div>
      </div>
    </article>
  );
};

RecipeBarbacoaBeefTaco.propTypes = {
  data: PropTypes.object.isRequired,
};

export default RecipeBarbacoaBeefTaco;
